import { FC } from 'react';
import ReserveRegist from './ReserveRegist';
import UseReserveRegist from './UseReserveRegist';

const ReserveRegistContainer: FC = () => {
  return <ReserveRegist {...UseReserveRegist()} />;
};

export default ReserveRegistContainer;
